import { useEffect, useRef } from "react";
import { Input } from "../../../components/ui/input";
import { createUrl, post } from "../../../network/AxiosInterceptor";
import { useAdmin } from "../../../contextApi/adminContext";
import { useNavigate } from "react-router-dom";

const AdminLogin = () => {
    const navigate = useNavigate();
    const usernameRef= useRef("");
    const passwordRef= useRef("");

    const {admin,setAdmin} = useAdmin();

    useEffect(() => {
        if(localStorage.getItem("uid") && localStorage.getItem("role")){
            post(createUrl("/api/admin/find"), {
                username: localStorage.getItem("uid"),
                password: localStorage.getItem("role")
            }).then((res) => {
                if(res.data.status == true){
                    setAdmin({firstName: res?.data?.data?.username,role: res?.data?.data?.role});
                    navigate("/admin-panel/v1")
                }else{
                    localStorage.removeItem("uid");
                    localStorage.removeItem("role");
                }
            })
        }
    },[])

    const submitHandler = () => {
        post(createUrl("/api/admin/find"), {
            username: usernameRef.current.value,
            password: passwordRef.current.value
        }).then((res) => {
            if(res.data.status == true){
                localStorage.setItem("uid",res?.data?.data?.username);
                localStorage.setItem("role",res?.data?.key);
                setAdmin({firstName: res?.data?.data?.username,role: res?.data?.data?.role});
                navigate("/admin-panel/v1")
            }else{
                alert("Invalid Credentials");
            }
        })
    }

    return (
        <div className="h-screen w-screen bg-white pt-[4vw] lg:pt-[2vw]">
            <h1 className="text-[5vw] lg:text-[3vw] font-semibold text-center">Admin Login</h1>
            <div className="w-[80%] mt-[12vw] mx-auto space-y-[8vw] py-[8vw] px-[4vw] rounded-md lg:w-[30vw] h-[min-content] lg:ml-[35vw] lg:px-[2vw] lg:pt-[2vw] lg:pb-[2vw] lg:space-y-[2vw] lg:rounded-lg lg:mt-[2vw] border border-gray-300 flex flex-col">
                <Input 
                placeholder="Username"
                type="text"
                ref={usernameRef}
                />
                <Input 
                placeholder="Password"
                type="password"
                ref = {passwordRef}
                />
                <button onClick={submitHandler} className="bg-[#4285F4] text-white lg:rounded-lg rounded-sm text-[3vw] lg:text-[1.2vw] w-[100%] h-[10vw] lg:h-[2.5vw] lg:w-[9vw] mx-auto">Login</button>
            </div>
        </div>
    )
};

export default AdminLogin;